import { _ } from 'ajv';
import { and } from 'ajv/dist/compile/codegen';
import { useFunc } from 'ajv/dist/compile/util';
import { DataType, checkDataType } from 'ajv/dist/compile/validate/dataType';
export const uniqueItemProperties = {
    keyword: 'uniqueItemProperties',
    type: 'array',
    schemaType: 'array',
    code(cxt) {
        const { gen, data, schemaCode } = cxt;
        if (!schemaCode)
            return;
        const valid = gen.let('valid');
        gen.block(validate);
        cxt.ok(valid);
        function validate() {
            const keys = gen.const('keys', schemaCode);
            const k = gen.let('k');
            const i = gen.let('i', _ `${data}.length`);
            const j = gen.let('j');
            cxt.setParams({ keys, k, i, j });
            gen.assign(valid, true);
            gen.if(_ `${i} > 1`, () => loop(keys, k, i, j));
        }
        function loop(keys, k, i, j) {
            const key = gen.name('key');
            const x = gen.name('x');
            const y = gen.name('y');
            const eql = useFunc(gen, { code: 'require("ajv/dist/runtime/equal").default' });
            const outer = gen.name('outer');
            const xIsNotObject = checkDataType('object', x, undefined, DataType.Wrong);
            const yIsObject = checkDataType('object', y);
            gen.label(outer).for(_ `${k} = 0; ${k} < ${keys}.length; ${k}++`, () => {
                gen.let(key, _ `${keys}[${k}]`);
                gen.for(_ `${i} = ${data}.length; ${i}--;`, () => {
                    gen.let(x, _ `${data}[${i}]`);
                    gen.if(xIsNotObject, _ `continue`);
                    gen.for(_ `${j} = ${i}; ${j}--;`, () => {
                        gen.let(y, _ `${data}[${j}]`);
                        gen.if(and(yIsObject, _ `${eql}(${x}[${key}], ${y}[${key}])`), () => {
                            cxt.error();
                            gen.assign(valid, false).break(outer);
                        });
                    });
                });
            });
        }
    },
    metaSchema: {
        type: 'array',
        items: { type: 'string' }
    }
};
//# sourceMappingURL=uniqueItemProperties.js.map